import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  NgbActiveModal,
  NgbDateAdapter,
  NgbDateNativeAdapter,
  NgbDateParserFormatter,
  NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';
import { CustomNgbDateFormatter } from 'src/app/dependencies/custom-ngb-date-formatter';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-date-range-selection-modal',
  templateUrl: './date-range-selection-modal.component.html',
  styleUrl: './date-range-selection-modal.component.less',
  providers: [
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomNgbDateFormatter }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DateRangeSelectionModalComponent implements OnInit {
  constructor(
    private ToastService: ToastService,
    private ActiveModal: NgbActiveModal
  ) {}

  minDatePickerDate: NgbDateStruct = { day: 1, month: 1, year: 1900 };
  maxDatePickerDate: NgbDateStruct = {
    day: new Date().getDate(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  };

  minEndDatePickerDate: NgbDateStruct = { day: 1, month: 1, year: 1900 };

  DateSelectionFormGroup = new FormGroup({
    startDate: new FormControl<null | Date>(null),
    endDate: new FormControl<null | Date>(null)
  });

  startDateChanged() {
    const {
      value: { startDate }
    } = this.DateSelectionFormGroup;

    if (startDate) {
      Object.assign(this.minEndDatePickerDate, {
        day: startDate.getDate(),
        month: startDate.getMonth() + 1,
        year: startDate.getFullYear()
      });
    }
  }

  close() {
    this.ActiveModal.dismiss();
  }

  continue() {
    const { value } = this.DateSelectionFormGroup;
    this.ActiveModal.close(value);
  }

  ngOnInit(): void {}
}
